function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.19 6L1.218 2.031a.747.747 0 010-1.06.756.756 0 011.063 0l4.5 4.498c.284.284.29.74.022 1.034l-4.519 4.528a.75.75 0 01-.531.219.75.75 0 01-.532-1.278L5.191 6z",
  fill: "#4F4F4F"
});

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    fill: "none"
  }, props), _ref);
}

export default SvgExpand;